import React, { useMemo, useState } from "react";
import { useUpdateUserModalOnboardingMutation } from "../../graphql/generated/graphql";
import { useAuth } from "../../hooks/useAuth";
import { useCompanionThreads } from "../../contexts/CompanionThreadsContext";
import WelcomeModal from "../../components/adminDashboard/WelcomeModal/WelcomeModal";

const WELCOME_MODAL_KEY = "companionWelcome";

function WelcomeModalContainer() {
  const { meData, refetchMe } = useAuth();
  const { showError } = useCompanionThreads();
  const [updateModalOnboarding] = useUpdateUserModalOnboardingMutation();
  const [isDismissed, setIsDismissed] = useState(false);

  const hasSeenWelcome = useMemo(() => {
    const modalOnboarding = meData?.me?.modalOnboarding || "";
    return modalOnboarding.split(",").includes(WELCOME_MODAL_KEY);
  }, [meData?.me?.modalOnboarding]);

  const handleDismiss = async () => {
    // Immediately hide the modal via local state
    setIsDismissed(true);

    const currentModalOnboarding = meData?.me?.modalOnboarding || "";
    const newValue = currentModalOnboarding ? `${currentModalOnboarding},${WELCOME_MODAL_KEY}` : WELCOME_MODAL_KEY;

    try {
      await updateModalOnboarding({
        variables: {
          modalOnboarding: newValue,
        },
      });

      try {
        await refetchMe();
      } catch (refetchErr) {
        const message = refetchErr instanceof Error ? refetchErr.message : "Failed to refresh your preferences.";
        showError({
          title: "Failed to save",
          message,
          onRetry: async () => {
            await refetchMe();
          },
          retryButtonText: "Retry",
        });
      }
    } catch (error) {
      const message = error instanceof Error ? error.message : "Failed to save your preferences. Please try again.";
      showError({
        title: "Failed to save",
        message,
        onRetry: async () => {
          setIsDismissed(false);
          await handleDismiss();
        },
        retryButtonText: "Retry",
      });
    }
  };

  if (hasSeenWelcome || isDismissed) {
    return null;
  }

  return <WelcomeModal visible onDismiss={handleDismiss} />;
}

export default WelcomeModalContainer;
